import * as React from 'react';
import { observer } from 'mobx-react';
import Dropzone = require('react-dropzone');
import { Button, FormControl, FormGroup, Panel, ControlLabel, InputGroup } from 'react-bootstrap';
import { observable, action, computed } from 'mobx';
import { ApiStore } from '../../stores/ApiStore';
import { inject, bind } from '../../utils/decorators';
import { VorgangStore } from '../../stores/VorgangStore';
import FaIcon from '../site/FaIcon';
interface IProtokollUpload {
  vorlage: string;
  vorgangId: string;
  dokumentenBezeichnung: string;
  dokumentTitel?: string;
  text?: string;
  /** (optional) Steuert ob der Vorgang nach dem Hochladen des Dokuments abgeschlossen wird (standardmäßig ja) */
  abschliessen?: boolean;
}

@observer
export default class VorlageUpload extends React.Component<IProtokollUpload, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable acceptedFile?: File;
  @observable dragging: boolean = false;
  @observable dokumentTitel: string = '';

  componentDidMount() {
    this.dokumentTitel = this.props.dokumentTitel ? this.props.dokumentTitel : '';
  }

  componentWillReceiveProps(nextProps: IProtokollUpload) {
    if (nextProps.dokumentTitel !== this.props.dokumentTitel) {
      this.dokumentTitel = nextProps.dokumentTitel ? nextProps.dokumentTitel : '';
    }
  }

  @computed get fileSelected() {
    return this.acceptedFile !== undefined;
  }

  @computed get fileSize() {
    return (this.acceptedFile && this.acceptedFile.size && !isNaN(this.acceptedFile.size))
      ? `(~${Math.ceil(10 * this.acceptedFile.size / 1024 / 1024) / 10} MB)`
      : '';
  }

  @bind @action handleFileDrop(accepted: File[]) {
    if (accepted.length > 0) {
      this.acceptedFile = accepted.shift();
    }
    this.handleSetDragging(false);
  }

  @bind @action handleFileDropRejected(rejected: File[]) {
    this.handleClearAcceptedFile();
    this.handleSetDragging(false);
  }

  @bind @action handleClearAcceptedFile() {
    this.acceptedFile = undefined;
  }

  @action handleSetDragging(dragging: boolean) {
    this.dragging = dragging;
  }

  @bind async handleUpload() {
    if (this.acceptedFile && (this.dokumentTitel !== '')) {
      const { vorgangId } = this.props;
      const response = await this.apiStore.vorgangProtokollUpload(vorgangId, this.dokumentTitel, this.acceptedFile, this.props.abschliessen);
      if (response.ok) {
        this.handleClearAcceptedFile();
        this.vorgangStore.loadVorgang(vorgangId);
      }
    }
  }

  @bind @action handleDokumenttitelChanged(event: React.FormEvent<FormControl>) {
    this.dokumentTitel = (event.target as HTMLInputElement).value;
    this.dokumentTitel = this.dokumentTitel.replace(/[\\\/:\*\?"<>|]/ig, '_');
  }

  @computed get validiereDokumenttitel() {
    return (this.dokumentTitel === '') ? 'error' : undefined;
  }

  render() {
    // tslint:disable-next-line:no-any
    let dropZone: any;
    let fileName = (this.acceptedFile) ? this.acceptedFile.name : '';

    return (
      <Panel
        header={`${this.props.dokumentenBezeichnung} hochladen`}
        bsStyle="warning"
        footer={(
          <div className="text-right">
            {this.fileSelected ? (
              <div>
              <Button onClick={this.handleClearAcceptedFile}>Abbrechen</Button>
              <Button bsStyle="primary" onClick={this.handleUpload}>Ausgewählte Datei hochladen</Button>
              </div>
            ) : (
              <Button onClick={() => dropZone.open()}>Datei auswählen</Button>
            )}
          </div>
        )}
      >
        <Dropzone
          accept=".pdf,.docx,.tif,.tiff,.xlsx,.jpg,.jpeg,.msg"
          ref={ref => dropZone = ref}
          disableClick={true}
          style={{}}
          className={`upload-dropzone ${this.dragging ? 'upload-dropzone-dragging' : ''}`}
          onDragEnter={() => this.handleSetDragging(true)}
          onDragLeave={() => this.handleSetDragging(false)}
          onDropAccepted={this.handleFileDrop}
          onDropRejected={this.handleFileDropRejected}
        >
          {this.fileSelected ? (
            <div>
              <h4>Ausgewählt: {fileName} {this.fileSize}</h4>
              <p>Das Hochladen eines ausgefüllten Dokumentes markiert den Vorgang als abgeschlossen. Ein erneutes Hochladen ist erst nach Freigabe durch einen Mitarbeiter der DIQ Zert GmbH wieder möglich.</p>
              <FormGroup validationState={this.validiereDokumenttitel} controlId="Dokumenttitel">
                <InputGroup>
                  <InputGroup.Addon>
                    <ControlLabel>Dokumenttitel</ControlLabel>
                  </InputGroup.Addon>
                  <FormControl
                    type="text"
                    label="Dokumenttitel"
                    value={this.dokumentTitel}
                    maxLength={255}
                    onChange={this.handleDokumenttitelChanged}
                  />
                </InputGroup>
              </FormGroup>
            </div>
          ) : (
            <div>
              <p>
                {(this.props.text == null) && <span>Klicken Sie auf <b>Auswählen</b> oder ziehen Sie die von Ihnen ausgefüllte Vorlage per Drag&Drop auf diese Fläche, um den Upload vorzubereiten.</span>}
                {(this.props.text != null) && <span>{this.props.text}</span>}
                <br/>Unterstützte Formate: <FaIcon icon="file-word-o" />docx, <FaIcon icon="file-pdf-o" />pdf, <FaIcon icon="file-image-o" />jp(e)g und <FaIcon icon="file-text-o" />tif(f)
              </p>
            </div>
          )}
        </Dropzone>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorlageUpload.tsx